// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__v0R7P","loaderOuter":"PageOverlayLoader_loaderOuter___akeh"};